/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_BodyInputs */

const cs_pwa_install_body = /** @type {(inputs: Pwa_Install_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidejte na plochu pro rychlejší práci ve stylu aplikace.`)
};

const en_pwa_install_body = /** @type {(inputs: Pwa_Install_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to your home screen for a faster, app-like experience.`)
};

/**
* | output |
* | --- |
* | "Add to your home screen for a faster, app-like experience." |
*
* @param {Pwa_Install_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_body = /** @type {((inputs?: Pwa_Install_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_body(inputs)
	return cs_pwa_install_body(inputs)
});